import { useWishlistAmount, useWishlistStore } from "@features/favourite/wishlist-store";
import type { ProductType } from "@type/global";
import * as React from "react";

import Amount from "./amount";
import type { Wishlist } from "@type/wishlist";

interface ProductAmountType {
  wishlist: Wishlist;
  product: ProductType;
}

function ProductAmountWishlist({ wishlist, product }: ProductAmountType) {
  const addOrUpdate = useWishlistStore((state) => state.addOrUpdate);
  const amount = useWishlistAmount({ wishlistId: wishlist.id, productPid: product.pid });

  const wishlistId = wishlist.id;
  const change = React.useCallback(
    (value: number) => {
      addOrUpdate({ quantity: value, product, wishlistId });
    },
    [product, wishlistId]
  );
  return <Amount value={amount ?? 0} onChange={change} />;
}

export default ProductAmountWishlist;
